import TablePagination from "components/Table/Pagination";
import usePagination from "components/Table/Pagination/usePagination";
import TableSimple from "ds/components/TableSimple";
import useErrorHandle from "hooks/useErrorHandle";

import ScanResourcesEmptyState from "./components/EmptyState";
import SCAN_RESOURCES_TABLE_CELLS from "./components/Table/Cells";
import {
  SCAN_RESOURCES_FILTERS_ORDER_KEY,
  SCAN_RESOURCES_LIMIT,
  SCAN_RESOURCES_LIMIT_STORAGE_KEY,
  SCAN_RESOURCES_PAGINATION_OPTIONS,
  SCAN_RESOURCES_SORT_CONFIG,
} from "./components/Table/constants";
import useScanResourcesTableStore from "./components/Table/useStore";
import ScanResourcesFiltersLayout from "./FiltersLayout";
import useScanResources from "./useScanResources/useScanResources";
import useScanResourcesSuggestions from "./useScanResources/useSuggestions";

const ScanResources = () => {
  const {
    resources,
    error,
    loadingContent,
    loadingPagination,
    hasRows,
    hasNoResults,
    loadScanResources,
    endCursor,
    startCursor,
    paginationResetKey,
  } = useScanResources();

  const { filters, filtersMap, sortOptions, filtersLoading, refetchActiveSections, filteredCount } =
    useScanResourcesSuggestions();

  const {
    rowsPerPage,
    setRowsPerPage,
    from,
    to,
    lastPage,
    page,
    goToNextPage,
    goToPrevPage,
    goToFirstPage,
    goToLastPage,
  } = usePagination({
    fetchItems: loadScanResources,
    endCursor,
    startCursor,
    allItemsCount: filteredCount,
    visibleItemsCount: resources.length,
    initialLimit: SCAN_RESOURCES_LIMIT,
    storageKey: SCAN_RESOURCES_LIMIT_STORAGE_KEY,
    resetKey: paginationResetKey,
    loading: loadingContent,
  });

  const ErrorContent = useErrorHandle(error);

  if (ErrorContent) {
    return ErrorContent;
  }

  return (
    <ScanResourcesFiltersLayout
      filters={filters}
      filtersMap={filtersMap}
      sortOptions={sortOptions}
      filtersLoading={filtersLoading}
      refetchActiveSections={refetchActiveSections}
      showSearch={hasRows || hasNoResults}
    >
      {(hasRows || loadingContent) && (
        <>
          <TableSimple
            data={resources}
            loading={loadingContent}
            store={useScanResourcesTableStore}
            ariaLabel="Scan resources table"
            cellPerColumn={SCAN_RESOURCES_TABLE_CELLS}
            filtersStorageKey={SCAN_RESOURCES_FILTERS_ORDER_KEY}
            rowsPerPage={rowsPerPage}
            sortConfig={SCAN_RESOURCES_SORT_CONFIG}
          />
          <TablePagination
            from={from}
            to={to}
            loading={loadingPagination}
            goToNextPage={goToNextPage}
            setRowsPerPage={setRowsPerPage}
            goToPrevPage={goToPrevPage}
            goToFirstPage={goToFirstPage}
            goToLastPage={goToLastPage}
            rowsPerPage={rowsPerPage}
            itemsCount={filteredCount}
            lastPage={lastPage}
            page={page}
            paginationOptions={SCAN_RESOURCES_PAGINATION_OPTIONS}
          />
        </>
      )}

      {!hasRows && !loadingContent && <ScanResourcesEmptyState hasNoResults={hasNoResults} />}
    </ScanResourcesFiltersLayout>
  );
};

export default ScanResources;
